import { useTranslation } from 'react-i18next'

import { ArrowsLeftRightIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

const EarningsRetainedAsExchanges = ({ earningsRetainedAsExchanges, currency }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      status={statisticStatuses.success}
      Icon={ArrowsLeftRightIcon}
      label={t('Ingresos retenidos en cambios')}
      value={<AnimatedNumber target={earningsRetainedAsExchanges} format="currency" currency={currency} />}
    />
  )
}

export default EarningsRetainedAsExchanges
